import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../pipes/translate.pipe';
import { TranslateOrPipe } from '../pipes/translate-or.pipe';
import { CountryCodeFilterPipe } from '../pipes/country-code-filter.pipe';
import { FileSizePipe } from '../pipes/file-size.pipe';
import { AppendToBodyDirective } from '../directives/append-to-body.directive';

@NgModule({
  declarations: [TranslatePipe, TranslateOrPipe, CountryCodeFilterPipe, FileSizePipe],
  imports: [CommonModule, AppendToBodyDirective],
  exports: [TranslatePipe, TranslateOrPipe, CountryCodeFilterPipe, FileSizePipe, AppendToBodyDirective]
})
export class SharedModule {}
